import { forwardRef } from '@chakra-ui/react';

import { Text } from '@frontend/components';

import { useTitleBlockContext } from './utils/TitleBlockContext';

const sizeBasedProps = {
  lg: {
    position: 'relative',
    paddingLeft: 1.5,
    _before: {
      content: `'_'`,
      color: 'transparent',
      bg: 'brand.secondary',
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      w: 0.5,
    },
  },
  md: {
    position: 'relative',
    paddingLeft: '0.6875rem',
    _before: {
      content: `'_'`,
      color: 'transparent',
      bg: 'brand.secondary',
      position: 'absolute',
      top: '0.125rem',
      bottom: '0.125rem',
      left: 0,
      w: '0.1875rem',
    },
  },
};

const TitleBlockDescription = forwardRef(
  ({ description, children, ...props }, ref) => {
    const { size, sizes } = useTitleBlockContext();
    const defaultSize = 'lg';

    return (
      <Text
        ref={ref}
        size={sizes[size].descFontSize}
        {...(sizeBasedProps[size] ?? sizeBasedProps[defaultSize])}
        {...props}
      >
        {description} {children}
      </Text>
    );
  },
);

export default TitleBlockDescription;
